import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";

export default function VerifyPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/verify/${id}`).then((r) => setData(r.data)).catch(() => setData({ verified: false })).finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-6" data-testid="verify-page">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl overflow-hidden">
        {loading ? (
          <div className="py-20 flex justify-center"><Loader2 className="animate-spin text-indigo-500" /></div>
        ) : data?.verified ? (
          <>
            <div className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-6 text-center">
              <ShieldCheck className="mx-auto mb-2" size={40} />
              <h1 className="font-bold text-lg">Verified Student</h1>
              <p className="text-white/80 text-sm">{data.school_name}</p>
            </div>
            <div className="p-6 space-y-3 text-sm" data-testid="verify-details">
              <Row k="Name" v={data.name} />
              <Row k="Admission No." v={data.admission_no} />
              <Row k="Class" v={`${data.class_name || "—"} ${data.section || ""}`} />
              <Row k="Session" v={data.session} />
              <p className="text-center text-xs text-emerald-600 pt-2">✔ This is a genuine record issued by the school.</p>
            </div>
          </>
        ) : (
          <div className="px-6 py-16 text-center text-slate-500">
            <ShieldX className="mx-auto mb-3 text-rose-500" size={40} />
            <h1 className="font-bold text-lg text-slate-800">Not Verified</h1>
            <p className="text-sm mt-1">No matching record was found for this code.</p>
          </div>
        )}
      </div>
    </div>
  );
}

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-3 border-b border-slate-100 pb-2">
    <span className="text-slate-500">{k}</span>
    <span className="font-medium text-slate-800 text-right">{v || "—"}</span>
  </div>
);
